export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          爆料投稿
        </h2>
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-6 md:p-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-send-line text-2xl text-accent-500"></i>
              </div>
              <div>
                <h3 className="font-heading text-lg text-foreground-950 mb-1">你有大赛猛料？我们等你来爆</h3>
                <p className="text-sm text-foreground-500">全网征集每日大赛独家爆料与现场素材</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6">
              <div className="bg-secondary-50 rounded-xl p-4 text-center">
                <i className="ri-wechat-line text-2xl text-accent-500 mb-2 block"></i>
                <span className="text-xs text-foreground-600">微信公众号</span>
                <p className="text-sm font-medium text-foreground-800 mt-1 whitespace-nowrap">吃瓜入口官方</p>
              </div>
              <div className="bg-secondary-50 rounded-xl p-4 text-center">
                <i className="ri-mail-line text-2xl text-accent-500 mb-2 block"></i>
                <span className="text-xs text-foreground-600">投稿邮箱</span>
                <p className="text-sm font-medium text-foreground-800 mt-1 whitespace-nowrap">tips@chigua.example.com</p>
              </div>
              <div className="bg-secondary-50 rounded-xl p-4 text-center">
                <i className="ri-chat-smile-2-line text-2xl text-accent-500 mb-2 block"></i>
                <span className="text-xs text-foreground-600">私信联系</span>
                <p className="text-sm font-medium text-foreground-800 mt-1 whitespace-nowrap">微博 @吃瓜入口</p>
              </div>
            </div>
            <p className="text-xs text-foreground-400 text-center">
              投稿内容一经采用将注明来源，保护投稿人隐私信息。商业合作请备注合作意向。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}